import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})

export class ConsignmentService {
    private baseURL: string;
    constructor(private http: HttpClient) {
        this.baseURL = environment.apiBaseUrl;
    }

    getConsignmentProductByMarket(): Observable<any> {
        return this.http.get<any>(
            `${this.baseURL}/ConsignmentInventory/GetConsignmentProductByMarket`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    return res.body as any;
                }),
                catchError(this.handleError)
            );
    }

    getConsignmentProductBySearchValue(field: number, value: string): Observable<any> {
        return this.http.get<any>(
            `${this.baseURL}/ConsignmentInventory/GetConsignmentProductBySearchValue?field=${field}&value=${encodeURIComponent(value)}`,
            { observe: 'response' }
        ).pipe(
            map(res => res.body as any),
            catchError(this.handleError)
        );
    }

    getConsignmentProductForPOS(field: number, value: string): Observable<any> {
        return this.http.get<any>(
            `${this.baseURL}/ConsignmentInventory/GetConsignmentProductForPOS?field=${field}&value=${encodeURIComponent(value)}`,
            { observe: 'response' }
        ).pipe(
            map(res => res.body as any),
            catchError(this.handleError)
        );
    }

    saveConsignmentProductByMarket(data: any): Observable<any> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        const url = `${this.baseURL}/ConsignmentInventory/SaveConsignmentProductByMarket`;
        return this.http.post<any>(url, data, options)
            .pipe(
                map(res => {
                    const response = res as any;
                    return response;
                }),
                catchError(this.handleError)
            );
    }

    deleteConsignmentProductById(id: number): Observable<any> {
        return this.http.delete(`${this.baseURL}/ConsignmentInventory/DeleteConsignmentProductById/${id}`,
            {
                observe: 'response'
            }).pipe(
                map((res: HttpResponse<any>) => res.body),
                catchError(this.handleError)
            );
    }

    getConsignmentBoothIDs(): Observable<any> {
        return this.http.get<any>(
            `${this.baseURL}/ConsignmentInventory/GetConsignmentBoothIDs`,
            { observe: 'response' }
        ).pipe(
            map(res => {
                return res.body as any;
            }),
            catchError(this.handleError)
        );
    }

    getNextConsignmentAutoId(): Observable<any> {
        return this.http.get<any>(
            `${this.baseURL}/ConsignmentInventory/GetNextConsignmentAutoId`,
            { observe: 'response' }
        ).pipe(
            map(res => {
                return res.body as any;
            }),
            catchError(this.handleError)
        );
    }

    private handleError(error: HttpErrorResponse) {
        console.error('server error:', error);
        if (error.error instanceof Error) {
            const errMessage = error.error.message;
            return throwError(errMessage);
        }
        return throwError(error || 'Node.js server error');
    }
}
